import { AccountData } from '../api';
import { mb } from '../common/theme/mbTokens';
import { accountSchedulerConfigs } from './agendaView/utils/occupancyMath';

export type RoomColor = { dot: string; soft: string };

export const roomColorForIndex = (index: number): RoomColor => mb.rooms[Math.abs(index) % mb.rooms.length];

/** Rooms are numbered in config order across every scheduler config, cycling after four. Unknown → room 1. */
export const roomColorOf = (account: AccountData, configId: string, areaId: string): RoomColor => {
  const areas = accountSchedulerConfigs(account).flatMap((config) =>
    (config.areas ?? []).map((area) => ({ configId: config.id, areaId: area.id })),
  );
  return roomColorForIndex(
    Math.max(
      areas.findIndex((area) => area.configId === configId && area.areaId === areaId),
      0,
    ),
  );
};
